import React from "react";
import { Box, BoxProps, useTheme } from "@mui/material";

const LIAccountDataRow: React.FC<BoxProps> = ({ children, sx = {}, ...props }) => {
    const theme = useTheme();
    return (
        <Box
            className="account-data-row"
            sx={{
                "&:last-child": {
                    borderRadius: `0 0 12px 12px`,
                },
                "&:first-child": {
                    borderRadius: `12px 12px 0 0`,
                },
                padding: `1.5rem`,
                display: `flex`,
                marginBottom: `5px`,
                background: `#FFF`,
                border: theme.palette.account.whiteboxBorder,
                ...sx,
            }}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            {...props}
        >
            {children}
        </Box>
    );
};

export default LIAccountDataRow;
